import { Outlet } from 'react-router';
import {
  ConsulateAuthorization,
  ProvinceAuthorization,
  ForeignStateAuthorization,
  TerritoryAuthorization,
  RegionAuthorization,
  MunicipalityAuthorization,
  SystemAuthorizations,
} from 'shell/authorizations/system';
import { RoutesConfig } from 'shell/router/routes-config';
import PageConsulateListInitializer from '../pages/consulate';
import ConsulateDetailPage from '../pages/consulate/detail';
import ConsulateEditPage from '../pages/consulate/edit';
import ConsulateListPage from '../pages/consulate/list';
import ConsulateNewPage from '../pages/consulate/new';
import PageProvinceListInitializer from '../pages/province';
import ProvinceDetailPage from '../pages/province/detail';
import ProvinceEditPage from '../pages/province/edit';
import ProvinceListPage from '../pages/province/list';
import ProvinceNewPage from '../pages/province/new';
import PageForeignStateListInitializer from '../pages/state';
import ForeignStateDetailPage from '../pages/state/detail';
import ForeignStateEditPage from '../pages/state/edit';
import ForeignStateListPage from '../pages/state/list';
import ForeignStateNewPage from '../pages/state/new';
import RegionListPage from '../pages/region/list';
import PageRegionListInitializer from '../pages/region';
import RegionEditPage from '../pages/region/edit';
import RegionDetailPage from '../pages/region/detail';
import RegionNewPage from '../pages/region/new';
import PageTerritoryListInitializer from '../pages/territory';
import TerritoryDetailPage from '../pages/territory/detail';
import TerritoryEditPage from '../pages/territory/edit';
import TerritoryListPage from '../pages/territory/list';
import TerritoryNewPage from '../pages/territory/new';
import PageMunicipalityListInitializer from '../pages/municipality';
import MunicipalityListPage from '../pages/municipality/list';
import {
  UpdateMunicipalityItalian,
  ChangeNameMunicipalityItalian,
} from '../pages/municipality/edit-italian';
import {
  UpdateMunicipalityForeign,
  ChangeNameMunicipalityForeign,
} from '../pages/municipality/edit-foreign';
import MunicipalityDetailEndedPage from '../pages/municipality/detail/ended';
import MunicipalityNewItalianPage from '../pages/municipality/new-italian';
import MunicipalityNewForeignPage from '../pages/municipality/new-foreign';
import MunicipalityEndedNewPage from '../pages/municipality/new-ended';
import {
  UpdateMunicipalityEnded,
  ChangeNameMunicipalityEnded,
  EndMunicipality,
} from '../pages/municipality/edit-ended';
import { NotFound } from 'shell/error/components/error-not-found';
import MunicipalityDetailForeignPage from '../pages/municipality/detail/foreign';
import MunicipalityDetailItalianPage from '../pages/municipality/detail/italian';

export const geographicRoutes: RoutesConfig = [
  {
    name: 'Geografiche',
    path: '',
    element: <Outlet />,
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
      },
      {
        path: '/comune',
        name: 'Comuni',
        authorizations: MunicipalityAuthorization,
        element: <PageMunicipalityListInitializer />,
        children: [
          {
            path: '',
            element: <MunicipalityListPage />,
          },
          {
            path: '/italia/modifica/:id',
            element: <UpdateMunicipalityItalian />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/italia/nome/:id',
            element: <ChangeNameMunicipalityItalian />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/italia/dettaglio/:id',
            element: <MunicipalityDetailItalianPage />,
            authorizations: [SystemAuthorizations.ComuneQuery],
          },
          {
            path: '/estero/modifica/:id',
            element: <UpdateMunicipalityForeign />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/estero/nome/:id',
            element: <ChangeNameMunicipalityForeign />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/estero/dettaglio/:id',
            element: <MunicipalityDetailForeignPage />,
            authorizations: [SystemAuthorizations.ComuneQuery],
          },
          {
            path: '/soppresso/modifica/:id',
            element: <UpdateMunicipalityEnded />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/soppresso/nome/:id',
            element: <ChangeNameMunicipalityEnded />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/soppresso/dettaglio/:id',
            element: <MunicipalityDetailEndedPage />,
            authorizations: [SystemAuthorizations.ComuneQuery],
          },
          {
            path: '/cessazione/:id',
            element: <EndMunicipality />,
            authorizations: [SystemAuthorizations.ComuneUpdate],
          },
          {
            path: '/italia/nuovo',
            element: <MunicipalityNewItalianPage />,
            authorizations: [SystemAuthorizations.ComuneAdd],
          },
          {
            path: '/soppresso/nuovo',
            element: <MunicipalityEndedNewPage />,
            authorizations: [SystemAuthorizations.ComuneAdd],
          },
          {
            path: '/estero/nuovo',
            element: <MunicipalityNewForeignPage />,
            authorizations: [SystemAuthorizations.ComuneAdd],
          },
        ],
      },
      {
        path: '/italia',
        name: '',
        children: [
          {
            path: '/regione',
            name: 'Regioni',
            authorizations: RegionAuthorization,
            element: <PageRegionListInitializer />,
            children: [
              {
                path: '',
                element: <RegionListPage />,
              },
              {
                path: '/modifica/:id',
                element: <RegionEditPage />,
                authorizations: [SystemAuthorizations.RegioneUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <RegionDetailPage />,
                authorizations: [SystemAuthorizations.RegioneQuery],
              },
              {
                path: '/nuovo',
                element: <RegionNewPage />,
                authorizations: [SystemAuthorizations.RegioneAdd],
              },
            ],
          },
          {
            path: '/provincia',
            name: 'Province',
            element: <PageProvinceListInitializer />,
            authorizations: ProvinceAuthorization,
            children: [
              {
                path: '',
                element: <ProvinceListPage />,
              },
              {
                path: '/nuovo',
                element: <ProvinceNewPage />,
                authorizations: [SystemAuthorizations.ProvinciaAdd],
              },
              {
                path: '/modifica/:id',
                element: <ProvinceEditPage />,
                authorizations: [SystemAuthorizations.ProvinciaUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <ProvinceDetailPage />,
                authorizations: [SystemAuthorizations.ProvinciaQuery],
              },
            ],
          },
        ],
      },
      {
        path: '/estero',
        name: '',
        children: [
          {
            path: '/stato',
            name: 'Stati Esteri',
            element: <PageForeignStateListInitializer />,
            authorizations: ForeignStateAuthorization,
            children: [
              {
                path: '',
                element: <ForeignStateListPage />,
              },
              {
                path: '/nuovo',
                element: <ForeignStateNewPage />,
                authorizations: [SystemAuthorizations.StatoesteroAdd],
              },
              {
                path: '/modifica/:id',
                element: <ForeignStateEditPage />,
                authorizations: [SystemAuthorizations.StatoesteroUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <ForeignStateDetailPage />,
                authorizations: [SystemAuthorizations.StatoesteroQuery],
              },
            ],
          },
          {
            path: '/consolato',
            name: 'Consolati',
            element: <PageConsulateListInitializer />,
            authorizations: ConsulateAuthorization,
            children: [
              {
                path: '',
                element: <ConsulateListPage />,
              },
              {
                path: '/nuovo',
                element: <ConsulateNewPage />,
                authorizations: [SystemAuthorizations.ConsolatoAdd],
              },
              {
                path: '/modifica/:id',
                element: <ConsulateEditPage />,
                authorizations: [SystemAuthorizations.ConsolatoUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <ConsulateDetailPage />,
                authorizations: [SystemAuthorizations.ConsolatoQuery],
              },
            ],
          },
          {
            path: '/territorio',
            name: 'Territori',
            element: <PageTerritoryListInitializer />,
            authorizations: TerritoryAuthorization,
            children: [
              {
                path: '',
                element: <TerritoryListPage />,
              },
              {
                path: '/nuovo',
                element: <TerritoryNewPage />,
                authorizations: [SystemAuthorizations.TerritorioAdd],
              },
              {
                path: '/modifica/:id',
                element: <TerritoryEditPage />,
                authorizations: [SystemAuthorizations.TerritorioUpdate],
              },
              {
                path: '/dettaglio/:id',
                element: <TerritoryDetailPage />,
                authorizations: [SystemAuthorizations.TerritorioQuery],
              },
            ],
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
